import { List, Map } from 'immutable';

import { getSize } from '../../../iterable/getSize';

import { INTERNATIONAL_PRICE_ITEM_TO_ATTRIBUTE_CURRENCY_MAP, OPERATIONS } from '../../../../constants/bulkEdit';
import { PRICE_ATTRIBUTE_CURRENCY_TO_API_KEY_MAP, VALUE } from '../../../../constants/product';
import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../../../constants/channels';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { EMPTY } from '../../../../constants';

export function price({ channel, preview }) {
  const payload = [];

  switch (channel) {
    case EBAY: {
      payload.push(
        Map({
          type: preview.getIn([ATTRIBUTE.PRICE, 'operation']),
          value: Map({
            rounding: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'cents']),
            type: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'price_type']),
            value: preview.getIn([ATTRIBUTE.PRICE, VALUE, VALUE]),
          }),
        })
      );

      break;
    }

    case ETSY: {
      payload.push(
        Map({
          type: preview.getIn([ATTRIBUTE.PRICE, 'operation']),
          value: List([
            Map({
              combination: null,
              offeringId: null,
              value: Map({
                rounding: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'cents']),
                type: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'price_type']),
                value: preview.getIn([ATTRIBUTE.PRICE, VALUE, VALUE]),
              }),
            }),
          ]),
        })
      );

      break;
    }

    case FAIRE: {
      let operationValue = EMPTY.MAP;

      for (const item of preview.getIn([ATTRIBUTE.PRICE, 'attributes'], EMPTY.SET).values()) {
        const { attribute, currency } = INTERNATIONAL_PRICE_ITEM_TO_ATTRIBUTE_CURRENCY_MAP[item];
        const key =PRICE_ATTRIBUTE_CURRENCY_TO_API_KEY_MAP[attribute][currency];
        const rounding = preview.getIn([ATTRIBUTE.PRICE, 'value', 'cents']);
        const type = preview.getIn([ATTRIBUTE.PRICE, 'value', 'price_type']);
        const value = preview.getIn([ATTRIBUTE.PRICE, 'value', 'value']);
        operationValue = operationValue.set(key, Map({ rounding, type, value }));
      }

      if (getSize(operationValue) > 0) {
        payload.push(Map({ type: preview.getIn([ATTRIBUTE.PRICE, 'operation']), value: operationValue }));
      }

      if (getSize(preview.get('attributes')) > 0) {
        return { payload, preview: Map({ attributes: preview.get('attributes') }) };
      }

      break;
    }

    case SHOPIFY: {
      if (preview.hasIn([ATTRIBUTE.PRICE, 'operation'])) {
        payload.push(
          Map({
            type: preview.getIn([ATTRIBUTE.PRICE, 'operation']),
            value: preview.getIn([ATTRIBUTE.PRICE, 'conversion'])
              ? List([EMPTY.MAP])
              : List([
                Map({
                  combination: null,
                  offeringId: null,
                  value: Map({
                    rounding: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'cents']),
                    type: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'price_type']),
                    value: preview.getIn([ATTRIBUTE.PRICE, VALUE, VALUE]),
                  }),
                }),
              ]),
          })
        );
      }

      if (preview.hasIn([ATTRIBUTE.PRICE, ATTRIBUTE.CHARGE_TAX])) {
        payload.push(
          Map({
            type: OPERATIONS[channel].CHARGE_TAX.SET,
            value: List([
              Map({
                combination: null,
                offeringId: null,
                value: Map({
                  taxable: preview.getIn([ATTRIBUTE.PRICE, ATTRIBUTE.CHARGE_TAX]),
                }),
              }),
            ]),
          })
        );
      }

      break;
    }

    default: {
      break;
    }
  }

  return { payload };
}
